import { Pipe, PipeTransform } from '@angular/core';
import type { AttendeeInformation, Place } from 'src/app/interfaces/interfaces';
import {
  parseMessageSegments,
  type MessageSegment,
} from './ai-chat-mention-format.util';

@Pipe({
  name: 'aiChatMessageSegments',
  standalone: false,
})
export class AiChatMessageSegmentsPipe implements PipeTransform {
  transform(
    text: string | null | undefined,
    attendees: AttendeeInformation[],
    places: Place[],
  ): MessageSegment[] {
    return parseMessageSegments(text ?? '', attendees ?? [], places ?? []);
  }
}
